<template>
  <v-app>
    <v-container style="background-color: #f8f9fb; margin: 0; padding: 0">
      <v-col cols="12">
        <filtro-consulta-massa @baixando-excel="showProgress = $event" />
      </v-col>
    </v-container>

    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title>Baixando arquivo...</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import FiltroConsultaMassa from "./components/FiltroConsultaMassa.vue";

export default {
  name: "ConsultaMassa",

  components: {
    FiltroConsultaMassa,
  },

  data() {
    return {
      showProgress: false,
    };
  },
};
</script>
